import React from "react";
import { BsLinkedin } from "react-icons/bs";
import { BsGithub } from "react-icons/bs";
import { FaGooglePlay } from "react-icons/fa";

const HeaderSocials = () => {
  return (
    <div className="header__socials">
      <a href="https://www.linkedin.com/in/maenghanem/" target="_blank">
        <BsLinkedin />
      </a>
      <a href="https://github.com/theintelligentguy" target="_blank">
        <BsGithub />
      </a>
      <a
        href="https://play.google.com/store/apps/dev?id=5245104504391848604"
        target="_blank"
      >
        <FaGooglePlay />
      </a>
    </div>
  );
};

export default HeaderSocials;
